import React, {useContext, useMemo} from "react"
import {DataContext} from "../context/DataContextProvider"
import _ from "lodash"
import {Box} from "@mui/material"

const DATA_PATHS = {
    vorname: "/kunde/vorname",
    nachname: "/kunde/nachname",
    strasse: "/kunde/adresse/strasse",
    hausnummer: "/kunde/adresse/hausnummer",
    plz: "/kunde/adresse/plz",
    ort: "/kunde/adresse/ort",
    geburtsdatum: "/kunde/geburtsdatum",
}

const formatDate = (date) => date?.split('-').reverse().join('.')

const KundenInfo = () => {
    const {getDataFromPointer} = useContext(DataContext)
    const customerData = useMemo(
        () => _.mapValues(DATA_PATHS, getDataFromPointer),
        [getDataFromPointer],
    )
    const {vorname, nachname, strasse, hausnummer, plz, ort, geburtsdatum} = customerData

    const formattedGeburtsdatum = useMemo(() => formatDate(geburtsdatum), [geburtsdatum])

    return (<Box display="flex" flexDirection="column" justifyContent="flex-start">
        <span>
            <span>{vorname}</span>{" "}
            <span>
                {nachname}
                {strasse || hausnummer ? "," : ""}
            </span>{" "}
            <span>{strasse}</span> <span>{hausnummer}
                {plz || ort ? "," : ""}</span> <span>{plz}</span>{" "}
            <span>{ort}</span>
        </span>
        <span>{formattedGeburtsdatum}</span>
        </Box>
    )
}

export default KundenInfo
